import { h, Host } from "@stencil/core";
import { AppState } from "../../service/app-state";
export class LanguageOverlay {
    constructor() {
        this.open = false;
        this.changeListener = () => {
            this.open = AppState.languageSelect;
        };
    }
    componentDidLoad() {
        this.open = AppState.languageSelect;
        AppState.addEventListener(this.changeListener);
    }
    disconnectedCallback() {
        AppState.removeEventListener(this.changeListener);
    }
    render() {
        return (h(Host, { key: 'd6e8da2cd5f8a8c464cb2944f7e27a12d42e4ab5', class: {
                'active': this.open
            } }, h("slot", { key: '2efcb6f60c49a111eab873f03b4e0001733fe3f8' })));
    }
    static get is() { return "uvex-language-overlay"; }
    static get states() {
        return {
            "open": {}
        };
    }
}
//# sourceMappingURL=language-overlay.js.map
